export default async (context) => {
  let isUserLoaded = false;

  if (!isUserLoaded){
    isUserLoaded = true;
    let isAuthenticatedUser = await context.store.dispatch(
      "account/AUTHENTICATE_USER"
    );
    if (isAuthenticatedUser) {
      await context.store.dispatch("account/ADDRESSES");
      await context.store.dispatch("account/SET_USER_ADDRESS");
    }

  }

};
